module.exports = __webpack_public_path__ + "img/fq1.caaab313.jpg";